export enum ManagementManagedServicesMutations {
    SET_FORM_VALUES = 'SET_FORM_VALUES',
    SET_CONTACT_INFORMATION = 'SET_CONTACT_INFORMATION',
    SET_TYPINGS = 'SET_TYPINGS',
}
